import styled, { css } from "styled-components";

import { fadeUpAnimation } from "@sellernote/shipda-kr/src/components/landing/index.styles";
import { COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { setElevationStyle } from "@sellernote/ui/src/sds-v2/styles/elevation";
import { setFontStyle } from "@sellernote/ui/src/sds-v2/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.div<{ backgroundImageUrl: string }>`
  display: flex;
  justify-content: center;
  padding: 88px 0 116px 0;

  background: ${({ backgroundImageUrl }) => `url(${backgroundImageUrl})`};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  ${mobile(css`
    padding: 60px 16px;
  `)};

  ${fadeUpAnimation};
`;

const contents = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 1128px;
  color: ${COLOR.wh};

  h3 {
    ${setElevationStyle("level2", "text-shadow")};
    animation-delay: 0.2s;

    ${mobile(css`
      ${setFontStyle("Head6")};
    `)};
  }

  p {
    margin-top: 8px;
    ${setFontStyle("Body1")};
    animation-delay: 0.4s;

    ${mobile(css`
      ${setFontStyle("Body3")};
    `)};
  }
`;

const buttonContainer = styled.div`
  margin-top: 24px;
  animation-delay: 0.6s;
`;

export default {
  container,
  contents,
  buttonContainer,
};
